import { render } from "./OrderComponent.vue?vue&type=template&id=22a8ffed&scoped=true"
import script from "./OrderComponent.vue?vue&type=script&lang=js"
export * from "./OrderComponent.vue?vue&type=script&lang=js"

import "./OrderComponent.vue?vue&type=style&index=0&id=22a8ffed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a8ffed"]])

export default __exports__